module.exports = __webpack_public_path__ + "media/images/application/icons/icon-list-85d183d3a07bd4b029015e001c08404e.svg";